import React, { useEffect, useRef, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import "./report.css";
import { useReactToPrint } from "react-to-print";
import { Link } from "react-router-dom";

// Let's add a fetchData method to our Table component that will be used to fetch
// new data when pagination state changes
// We can also add a loading state to let our table know it's loading new data
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length;

  return (
    <input
      value={filterValue || ""}
      className="form-control"
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${count} records...`}
    />
  );
}

const ReportTable = React.forwardRef(
  (
    {
      columns,
      data,
      onSort,
      fetchData,
      dateObject,
      loading,
      pageCount: controlledPageCount,
      canView,
      handleViewClick,
      canOpenBillPaid,
      handleOpenBillPaid,
      checkbox,
      handleCheckboxChange,
      checkedList,
      isChecked,
      getSelectAllValue,
      handleSelectAll,
      handleDeselectAll,
      canPreview,
      handlePreviewPod,
      handleDownloadPod,
      handleDeletePod,
      title,
    },
    ref
  ) => {
    const companyId =
      JSON.parse(sessionStorage.getItem("company_id"))?.company_id ?? "1";
    const role_id = JSON.parse(sessionStorage.getItem("role_id")).role_id;
    const fYear_fetch = JSON.parse(
      sessionStorage.getItem("financial_year_for_fetch")
    ).financial_year_for_fetch;
    const [customFilters, setCustomFilters] = React.useState({
      companyId: "" + companyId,
      fyear: fYear_fetch,
    });
    const [highlightRow, setHighlightRow] = React.useState([]);

    const filterTypes = React.useMemo(
      () => ({
        text: (rows, id, filterValue) => {
          return rows.filter((row) => {
            const rowValue = row.values[id];
            return rowValue !== undefined
              ? String(rowValue)
                  .toLowerCase()
                  .startsWith(String(filterValue).toLowerCase())
              : true;
          });
        },
      }),
      []
    );

    const defaultColumn = React.useMemo(
      () => ({
        Filter: DefaultColumnFilter,
      }),
      []
    );

    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      prepareRow,
      page,
      canPreviousPage,
      canNextPage,
      pageOptions,
      pageCount,
      gotoPage,
      nextPage,
      previousPage,
      setPageSize,
      state: { pageIndex, pageSize, sortBy },
    } = useTable(
      {
        columns,
        data,
        initialState: { pageIndex: 0 },
        defaultColumn,
        manualPagination: true,
        manualSortBy: true,
        autoResetPage: false,
        autoResetSortBy: false,
        pageCount: controlledPageCount,
        initialState: { pageSize: 100 },
      },
      useSortBy,
      usePagination
    );

    React.useEffect(() => {
      fetchData({ pageIndex, pageSize, sortBy, customFilters, dateObject });
    }, [fetchData, pageIndex, pageSize, sortBy, customFilters, dateObject]);

    const updateFilters = (e) => {
      let { name, value } = e.target;
      console.log("in update filter", e.target, name, value);
      gotoPage(0);
      setCustomFilters({ ...customFilters, [name]: value });
    };

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    const [tableWidth, setTableWidth] = useState("1000px");

    const tooglehighlightRow = (rowId) => {
      let hlRow = [...highlightRow];
      const idx = hlRow.indexOf(rowId);
      if (idx > -1) {
        hlRow.splice(idx, 1);
        setHighlightRow(hlRow);
      } else {
        hlRow.push(rowId);
        setHighlightRow(hlRow);
      }
    };

    useEffect(() => {
      console.log("!!!!!!!!");
      var wrapper1 = document.getElementById("wrapper1");
      var wrapper2 = document.getElementById("wrapper2");

      wrapper1.onscroll = function () {
        wrapper2.scrollLeft = wrapper1.scrollLeft;
      };
      wrapper2.onscroll = function () {
        wrapper1.scrollLeft = wrapper2.scrollLeft;
      };

      let tableWidthCurr = componentRef.current.offsetWidth + "px";
      setTableWidth(tableWidthCurr);
    }, []);

    const handleCheckbox = () => {
      if (allSelect) {
        setSelectedRows({ consignor_id: "", bill_id: "" });
      } else {
        const allRowIds = data.map((row) => row.bill_no);
        const allParty = data.map((row) => row.consignor_id);
        console.log("hdjdsbvbvsj", allParty);
        setSelectedRows({ bill_id: allRowIds, consignor_id: allParty });
      }
      setAllSelect(!allSelect);
    };

    // Render the UI for your table
    return (
      <>
        <div className="report-container">
          <div id="wrapper1">
            <div className="div1" style={{ width: `${tableWidth}` }}></div>
          </div>

          <div id="wrapper2">
            <table {...getTableProps()} className="div2" ref={componentRef}>
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {checkbox && (
                      <th>
                        <input
                          type="checkbox"
                          name="main_checkbox"
                          value={getSelectAllValue()}
                          onChange={() =>
                            getSelectAllValue()
                              ? handleDeselectAll()
                              : handleSelectAll()
                          }
                        />
                      </th>
                    )}

                    {canView && <th></th>}
                    {canOpenBillPaid && <th></th>}

                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps({
                          style: {
                            minWidth: column.minWidth,
                            width: column.width,
                            whiteSpace: "nowrap",
                          },
                        })}
                      >
                        <span
                          {...column.getSortByToggleProps({
                            style: {
                              minWidth: column.minWidth,
                              width: column.width,
                            },
                          })}
                        >
                          {column.render("Header")}
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " 🔽"
                              : " 🔼"
                            : ""}
                        </span>

                        <div>
                          {column.accessor && column.canFilter ? (
                            <input
                              name={column.id}
                              value={customFilters[column.id]}
                              className="form-control"
                              onChange={updateFilters}
                              placeholder={`Search records...`}
                              style={{
                                width: column.width,
                                minWidth: column.minWidth,
                              }}
                            />
                          ) : null}
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row);
                  const currentRowId = row.cells[0].value;
                  const highlightCurrentRow =
                    highlightRow.indexOf(currentRowId) > -1;

                  return (
                    <tr {...row.getRowProps()} className="report-cell-tr">
                      {/* ✔ row checkbox inside <td> */}
                      {checkbox && (
                        <td>
                          <input
                            type="checkbox"
                            checked={isChecked(row.cells)}
                            onChange={() => handleCheckboxChange(row.cells)}
                          />
                        </td>
                      )}

                      {canView && (
                        <td>
                          <button onClick={() => handleViewClick(row.cells)}>
                            Open
                          </button>
                        </td>
                      )}

                      {canOpenBillPaid && (
                        <td>
                          <button
                            onClick={() => handleOpenBillPaid(row.cells)}
                            style={{width: "75px"}}
                          >
                            Open Bill
                          </button>
                        </td>
                      )}

                      {row.cells.map((cell) => (
                        <td
                          onDoubleClick={() => tooglehighlightRow(currentRowId)}
                          {...cell.getCellProps()}
                          style={{
                            textDecoration: highlightCurrentRow
                              ? "underline"
                              : "",
                            whiteSpace: "nowrap",
                            textAlign: "center",
                            maxWidth: "0px",
                            overflow: "hidden",
                            textTransform: "uppercase",
                          }}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}

                      {canPreview && (
                        <button
                          style={{ margin: "2px" }}
                          onClick={() => handlePreviewPod(row)}
                        >
                          Preview
                        </button>
                      )}
                      {canPreview && (
                        <button
                          style={{ margin: "2px" }}
                          onClick={() => handleDownloadPod(row)}
                        >
                          Download
                        </button>
                      )}
                      {canPreview && (role_id === 1 || role_id === 2) && (
                        <button
                          style={{ margin: "2px" }}
                          onClick={() => handleDeletePod(row)}
                        >
                          Delete
                        </button>
                      )}
                    </tr>
                  );
                })}

                <tr>
                  {loading ? (
                    <td colSpan="10000">Loading...</td>
                  ) : (
                    <td colSpan="10000">
                      Showing {page.length} of ~{controlledPageCount * pageSize}{" "}
                      results
                    </td>
                  )}
                </tr>
              </tbody>
            </table>

          </div>
          <div className="pagination">
            <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              {"<<"}
            </button>{" "}
            <button onClick={() => previousPage()} disabled={!canPreviousPage}>
              {"<"}
            </button>{" "}
            <button onClick={() => nextPage()} disabled={!canNextPage}>
              {">"}
            </button>{" "}
            <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </button>{" "}
            <span>
              Page{" "}
              <strong>
                {pageIndex + 1} of {pageOptions.length}
              </strong>{" "}
            </span>
            <span>
              | Go to page:{" "}
              <input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                }}
                style={{ width: "100px" }}
              />
            </span>{" "}
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
              }}
            >
              {[10, 20, 30, 40, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
            <button onClick={handlePrint}>Print </button>
          </div>
        </div>
      </>
    );
  }
);

export default ReportTable;
